require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isEqualIcon = exports.isValidIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _settings = require("../core/settings");

var _MaterialCommunityIcon = require("./MaterialCommunityIcon");

var _theming = require("../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Icon.tsx";

var isImageSource = function isImageSource(source) {
  return typeof source === 'object' && source !== null && Object.prototype.hasOwnProperty.call(source, 'uri') && typeof source.uri === 'string' || typeof source === 'number' || _reactNative.Platform.OS === 'web' && typeof source === 'string' && (source.startsWith('data:image') || /\.(bmp|jpg|jpeg|png|gif|svg)$/.test(source));
};

var getIconId = function getIconId(source) {
  if (typeof source === 'object' && source !== null && Object.prototype.hasOwnProperty.call(source, 'uri') && typeof source.uri === 'string') {
    return source.uri;
  }

  return source;
};

var isValidIcon = function isValidIcon(source) {
  return typeof source === 'string' || isImageSource(source);
};

exports.isValidIcon = isValidIcon;

var isEqualIcon = function isEqualIcon(a, b) {
  return a === b || getIconId(a) === getIconId(b);
};

exports.isEqualIcon = isEqualIcon;

var Icon = function Icon(_ref) {
  var source = _ref.source,
      color = _ref.color,
      size = _ref.size,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["source", "color", "size", "theme"]);
  var direction = typeof source === 'object' && source.direction && source.source ? source.direction === 'auto' ? _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr' : source.direction : null;
  var s = typeof source === 'object' && source.direction && source.source ? source.source : source;
  var iconColor = color || theme.colors.text;

  if (isImageSource(s)) {
    return React.createElement(_reactNative.Image, (0, _extends2["default"])({}, rest, {
      source: s,
      style: [{
        transform: [{
          scaleX: direction === 'rtl' ? -1 : 1
        }]
      }, {
        width: size,
        height: size,
        tintColor: color,
        resizeMode: 'contain'
      }]
    }, _MaterialCommunityIcon.accessibilityProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86
      }
    }));
  } else if (typeof s === 'string') {
    return React.createElement(_settings.Consumer, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106
      }
    }, function (_ref2) {
      var icon = _ref2.icon;
      return icon({
        name: s,
        color: iconColor,
        size: size,
        direction: direction
      });
    });
  } else if (typeof s === 'function') {
    return s({
      color: iconColor,
      size: size,
      direction: direction
    });
  }

  return null;
};

var _default = (0, _theming.withTheme)(Icon);

exports["default"] = _default;